<template>
    <div class="page-container">
        <s-toolbar dark color="primary" label="Creación de Línea y Estaciones de trabajo"> 
            <v-btn icon color="white" @click="viewDetail()" title="Ver Detalle" class="mr-2">
                <v-icon>fa-brands fa-folder</v-icon>
            </v-btn>     
        </s-toolbar>

        <v-container fluid class="pt-6 pb-6">
            <v-row justify="center">
                <!-- SECCIÓN DE LÍNEAS -->
                <v-col cols="12" md="11" lg="10">
                    <v-card elevation="2" rounded="lg" class="pa-5 modern-card border-left-primary mb-6">
                        <div class="d-flex align-center mb-3">
                            <v-icon color="primary" large class="mr-3">mdi-chart-timeline-variant</v-icon>
                            <h2 class="text-h5 font-weight-bold primary--text mb-0">Gestión de Líneas</h2>
                        </div>
                        <p class="text-body-2 grey--text text--darken-1 mb-4">Crea y configura las líneas de producción indicando su cultivo y tipo de salida.</p>
                        <v-divider class="mb-6"></v-divider>
                        
                        <v-row class="align-center">
                            <v-col cols="12" lg="3" md="4" sm="12">
                                <s-text
                                    label="Descripción"
                                    v-model="LncDescription"
                                    ref="txtLncDescription">
                                </s-text>
                            </v-col>

                            <v-col cols="12" lg="2" md="4" sm="12">
                                <s-select-definition
                                    label="Cultivo"
                                    v-model="TypeCultive"
                                    :def="1173"
                                ></s-select-definition>
                            </v-col>

                            <v-col cols="12" lg="3" md="4" sm="12">	
                                <s-select                                      
                                    :items="ProductionCategory"
                                    v-model="CecID"  
                                    item-value="CecID"
                                    item-text="CecDescription"
                                    label="Salida de Congelamiento"
                                    ref="txtCecID">
                                </s-select>
                            </v-col>  

                            <v-col cols="12" lg="2" md="6" sm="12"> 
                                <s-select-definition 
                                    :def="1154" 
                                    label="Estado" 
                                    v-model="LncState">
                                </s-select-definition>  
                            </v-col>
                            
                            <v-col cols="12" lg="2" md="6" sm="12" class="mt-2 mt-lg-0">
                                <v-btn 
                                    color="primary" 
                                    elevation="2"
                                    @click="SaveLine()"
                                    class="text-none font-weight-bold"
                                >
                                    <v-icon left>mdi-plus-circle</v-icon>
                                    Crear Línea
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>

                <!-- SECCIÓN DE ESTACIÓN DE TRABAJO -->
                <v-col cols="12" md="11" lg="10">
                    <v-card elevation="2" rounded="lg" class="pa-5 modern-card border-left-teal">
                        <div class="d-flex align-center mb-3">
                            <v-icon color="teal" large class="mr-3">mdi-domain</v-icon>
                            <h2 class="text-h5 font-weight-bold teal--text mb-0">Gestión de Estaciones de Trabajo</h2>
                        </div>
                        <p class="text-body-2 grey--text text--darken-1 mb-4">Configura las estaciones de trabajo, asignándolas a una línea existente.</p>
                        <v-divider class="mb-6"></v-divider>
                        
                        <v-row class="align-center">
                            <v-col cols="12" lg="3" md="4" sm="12">
                                <s-text
                                    label="Sigla / Nombre"
                                    v-model="CttName"
                                    ref="txtCttName"
                                ></s-text>
                            </v-col>

                            <v-col cols="12" lg="2" md="4" sm="6">
                                <s-text
                                    label="Cant. Mesas"
                                    type="number"
                                    v-model="NumTable"
                                    ref="txtNumTable"
                                    :min="1"
                                ></s-text>
                            </v-col>

                            <v-col cols="12" lg="2" md="4" sm="6">
                                <s-text
                                    label="Capacidad (Personas)"
                                    v-model="CttCapacity"
                                    :min="0"
                                    :max="6"
                                    ref="txtCapacidad"
                                    type="number"
                                ></s-text>
                            </v-col>

                            <v-col v-if="NumTable > 1" cols="12" lg="2" md="4" sm="6">
                                <v-switch
                                    v-model="IsIntercalated"
                                    label="Intercalado"
                                    color="teal"
                                    hide-details
                                    class="mt-0"
                                ></v-switch>
                            </v-col>

                            <v-col v-if="NumTable == 1 || !IsIntercalated" cols="12" lg="2" md="4" sm="12">							
                                <s-select-definition
                                    label="Posición"
                                    v-model="CttPosition"
                                    :def="1426"
                                    ref="txtPosition"
                                ></s-select-definition>
                            </v-col>
                            
                            <v-col cols="12" lg="3" md="4" sm="12">
                                <s-select-definition
                                    label="Cultivo"
                                    v-model="TypeCultiveET"
                                    :def="1173"
                                    @change="listando($event)"	
                                ></s-select-definition>
                            </v-col>

                            <v-col cols="12" lg="4" md="4" sm="12">
                                <s-select
                                    label="Línea Asignada"
                                    :items="listLineas"
                                    v-model="LncID"
                                    item-value="LncID"
                                    item-text="LineDescriptionName"      
                                    ref="txtLinea"
                                ></s-select>
                            </v-col>

                            <v-col cols="12" lg="2" md="4" sm="12">
                                <s-select-definition
                                    label="Estado"
                                    v-model="CttStatus"
                                    :def="1154"
                                ></s-select-definition>
                            </v-col>

                            <v-col cols="12" lg="3" md="12" sm="12" class="mt-2 mt-lg-0">
                                <v-btn 
                                    color="teal" 
                                    class="white--text text-none font-weight-bold"
                                    elevation="2" 
                                    @click="SaveStationWork()"
                                >
                                    <v-icon left>mdi-plus-circle</v-icon>
                                    Crear Estación
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>

        <v-dialog
            v-model="dialogDetail" 
            v-if="dialogDetail"
            transition="dialog-bottom-transition"
            persistent>
            <line-station-detail @close="dialogDetail = false"></line-station-detail>
        </v-dialog>
    </div>
</template>
<script>
    import _sCreationTableService from "@/services/FrozenProduction/FrzCreateTableService.js"
    import _sProductionLine from '@/services/FrozenProduction/ProductionLine.js';    
    import _sFrzTypeExitCategoryService from "@/services/FrozenProduction/FrzTypeExitCategory.js"

    import LineStationDetail from './FrzLineStationWorkDetail.vue'
   
    import _sProductionCategory from '../../../services/FrozenProduction/ProductionCategory.js';
    export default{
        components:{
            LineStationDetail
        },
        data(){
            return {
                listLineas: [],
                LncDescription: '',
                PdcID: 0,
                TypeCultive: 1,
                TypeCultiveET: 1,
                LncState: 0,
                ProductionCategory: [],
                CttName: '',
                CttCapacity: 1,
                CttPosition: 0,
                IsIntercalated: true,
                LncID: 0,
                CttStatus: 0,
                dialogDetail: false,
                CecID: 0,
                NumTable: 1,
                StationWork: {}
            }
        },
        methods:{
            listando(type){           
                this.refresLines();
            },

            inputProdCategory(typeCultive){                
                _sProductionCategory.list(this.$fun.getUserID()).then(r =>{
                    if(r.status == 200)
                    {
                        
                        this.ProductionCategory = r.data;                    
                    }
                });   
            },
            SaveLine()
            {
                let line = {};
                if(this.LncDescription == '')
                {
                    this.$fun.alert("Ingrese Descripcion de Linea", "warning")
                    this.$refs.txtLncDescription.focus();
                    return;
                }
                if(this.CecID == 0)
                {
                    this.$fun.alert("Seleccione Tipo salida de congelamiento", "warning")
                    this.$refs.txtCecID.focus();
                    return;
                }
                line.LncDescription = this.LncDescription;
                line.CecID = this.CecID;
                line.TypeCultive = this.TypeCultive; 
                line.LncState = this.LncState;
                
                this.$fun.alert("Estas seguro de guardar?", "question").then((r) => {
                    if(r.value){
                        _sProductionLine.save(line, this.$fun.getUserID())
                        .then((r) => {
                            if(r.status == 200)
                            {
                                this.$fun.alert("Registrado correctamente", "success");
                                this.refresLines();
                            }
                        });
                    }
                });
                
            },
            SaveStationWork(){
                if(this.CttCapacity <= 0){
                    this.$fun.alert("La capacidad de personas debe ser mayor a 0","warning")
                    return;
                }

                if(this.CttName == '')
                {
                    this.$fun.alert("Ingrese Descripcion de Estacion de trabajo", "warning")
                    this.$refs.txtCttName.focus();
                    return;
                }
                this.StationWork.CttName = this.CttName;
                this.StationWork.CttCapacity = this.CttCapacity;
                this.StationWork.CttPosition = this.CttPosition; 
                           
                this.StationWork.LncID = this.LncID;
                this.StationWork.CttStatus = this.CttStatus;
                this.StationWork.UsrCreateID = this.$fun.getUserID();
                if(this.NumTable > 20)
                {
                    this.$fun.alert("Debe ingresar una cantidad menor de mesas", "error")
                    return;
                }
                this.$fun.alert("Estas seguro de guardar ?", "question").then((r) => {
                    if(r.value){
                        _sCreationTableService.saveNumTable(this.StationWork, this.NumTable, this.IsIntercalated, this.$fun.getUserID())
                        .then((r) => {
                            if(r.status == 200)
                            {
                                this.$fun.alert("Registrado correctamente", "success");
                                this.CttName = '';
                                this.CttCapacity = 1;
                            }
                        });
                    }
                });
            },
            refresLines()
            {
                _sCreationTableService
                .list(this.$fun.getUserID())
                .then((r) => {
                    this.listLineas = r.data.filter(line => line.typeCultive === this.TypeCultiveET);     
                    console.log("line",this.listLineas);         
                    if (this.listLineas.length > 0) {
                       // this.LncID = r.data[0].LncID;
                        
                    }
                });

                this.LncDescription = '';
                this.PdcID = 0;
                
            },
            viewDetail(){
                this.dialogDetail = true;
            }

        },
        created(){
            this.refresLines();
            this.inputProdCategory(0);
        }
    }
</script>

<style scoped>
.page-container {
    background-color: #f4f6f9;
    min-height: 100vh;
}
.border-left-primary {
    border-left: 5px solid #1976D2 !important;
}
.border-left-teal {
    border-left: 5px solid #009688 !important;
}
.modern-card {
    transition: all 0.3s ease;
}
.modern-card:hover {
    box-shadow: 0 8px 16px rgba(0,0,0,0.1) !important;
}
</style>